import React from "react";
import * as SubframeCore from "@subframe/core";
import { BreadcrumbItem } from "../../../types";
import { Link } from "react-router-dom";

interface BreadcrumbSkeletonProps {
  itemCount?: number;
}

const BreadcrumbSkeleton: React.FC<BreadcrumbSkeletonProps> = ({ 
  itemCount = 3 
}) => {
  return (
    <div className="sticky top-0 z-10 flex h-16 w-full flex-none items-center gap-2 px-4 md:pl-12 md:pr-6 py-4 flex-wrap mb-4 bg-white">
      {Array.from({ length: itemCount }).map((_, index) => (
        <React.Fragment key={index}>
          <div className="flex items-center gap-2">
            {/* Icon skeleton */}
            <div className="w-4 h-4 bg-gray-200 rounded animate-pulse" />
            {/* Label skeleton */}
            <div className="h-4 bg-gray-200 rounded animate-pulse" style={{ width: `${Math.random() * 60 + 40}px` }} />
          </div>
          {index < itemCount - 1 && (
            <span className="text-body font-body text-neutral-700">&gt;</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  isLoading?: boolean;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, isLoading = false }) => {
  if (isLoading) {
    return <BreadcrumbSkeleton itemCount={items.length || 3} />;
  }

  return (
    <div className="sticky top-0 z-10 flex h-16 w-full flex-none items-center gap-2 px-4 md:pl-12 md:pr-6 py-4 flex-wrap mb-4 bg-white">
      {items.map((item: BreadcrumbItem, index: number) => (
        <React.Fragment key={index}>
          <div className="flex items-center gap-2">
            <SubframeCore.Icon
              className="text-body font-body text-default-font"
              name={item.icon as any}
            />

           
            <span className="text-body font-body text-neutral-700">
              {item.href ? (
                <Link to={item.href}>
                  {item.label}
                </Link>
              ) : (
                item.label
              )}
            </span>
          </div>
          {index < items.length - 1 && (
            <span className="text-body font-body text-neutral-700">&gt;</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}; 